export default __webpack_public_path__ + "static/media/arrow_l.727e2338.svg";